// extracted by mini-css-extract-plugin
export default {"FormCard":"FormCard_FormCard__mf3uA"};